import { AdUser } from '@rbb/ng-web-template-lib';

export class ApproverDataToJson {
  users: AdUser[];
  deputyUsers: AdUser[];
  groupMembers: AdUser[];
  limit: number | null;
  mailNotification: boolean | undefined;
  forInformationOnly: boolean | undefined;

  constructor() {
    this.users = [];
    this.deputyUsers = [];
    this.groupMembers = [];
    this.limit = null;
    this.mailNotification = true;
    this.forInformationOnly = false;
  }
}
